import request from '@/utils/request'

export function login(data) {
  return request({
    url: `/api/auth/login`,
    method: 'post',
    base: 'origin',
    data
  })
}

export function queryUserInfo(data) {
  return request({
    url: `/api/user/${data}`,
    base: 'origin',
    method: 'get'
  })
}
//token失效刷新
export function tokenRefresh(data) {
  return request({
    url: `/api/auth/token`,
    method: 'post',
    base: 'origin',
    data
  })
}


// 根据邮箱查询用户是否存在
export function queryUserByEmail(data) {
  return request({
    url: `wit-energymetering-platform-api/user/queryUserByEmail`,
    method: 'post',
    data
  })
}

// 创建客户
export function createCustomer(data) {
  return request({
    url: `/api/customer`,
    method: 'post',
    base: 'origin',
    data
  })
} // userCustomerld

// 创建用户
export function createUser(data) {
  return request({
    url: `/api/user?sendActivationMail=false`,
    method: 'post',
    base: 'origin',
    data
  })
} // userName\userld

// 激活用户
export function activeUser(data) {
  return request({
    url: `/api/user/${data}/activationLinkInfo`,
    method: 'get',
    base: 'origin'
  })
}

// 设置用户名 密码
export function setUser(data) {
  return request({
    url: `/api/noauth/activate?sendActivationMail=true`,
    method: 'post',
    base: 'origin',
    data
  })
}
export function addUser(data) {
  return request({
    url: `/wit-energymetering-platform-api/user/addUser`,
    method: 'post',
    // base: "origin",
    data
  })
}
// http://192.168.2.69:9006/wit-energymetering-platform-api/user/queryAllAuthByUserCustomerId/13814000-1dd2-11b2-8080-808080808080
// // 侧边栏权限
export function generaMenu(data) {
  return request({
    url: `/wit-energymetering-platform-api/user/queryAllAuthByUserCustomerId/${data}`,
    method: 'get'
    // base: 'origin',
  })
}
//   url: `/wit-energymetering-platform-api/user/addUser`,
//   method: "post",
//   data,
// });
// }

//G5登录跳转
export function loginWithG5(data) {
  return request({
    url: `wit-energymetering-platform-api/auth/loginWithG5?userCode=` + data.userCode + '&agentCode=' + data.agentCode,
    method: 'get',
    data,
    headers: {
      'code': data.code
    },
  })
}

// 微云获取用户信息
export function getUserInfoG5(header = {}){
  return request({
    url: '/api/serp/getLoginUserInfo',
    method: 'get',
    headers: {
      ...header,
      'Content-Type': 'application/json'
    },
  })
}
//g5与能碳登录
export function loginG5And(data) {
  return request({
    url: `/wit-energymetering-platform-api/auth/login`,
    method: 'post',
    data
  })
}
